export default "__VITE_ASSET__a0ecce18__"